<template>
    <CDataTable
        :hover="false"
        :striped="true"
        :bordered="true"
        :items="data.results"
        :fields="fields"
        :column-filter="{external: true,lazy:true}"
        :column-filter-value="filters"
        :sorter="{external: true, resetable:true}"
        :loading="loading"
        :sorter-value="sorting"
        @update:column-filter-value="updateFilters"
        @update:sorter-value="updateSorting"
        class="custom-table custom-table--clean custom-table--has-filters"
    >
      <template #no-items-view>
        <div class="text-center">
          <h5 v-translate>No items found</h5>
        </div>
      </template>
      <template #sorting-icon="{ state, classes }">
        <div :class="classes">
          <CIcon name="cipCaretUp" size="lg" v-if="state === 'asc' || state === 0"></CIcon>
          <CIcon name="cipCaretUp" size="lg" v-else></CIcon>
        </div>
      </template>
      <template #under-table>
        <CPagination
            v-show="data.pagination.num_pages > 1"
            :activePage="data.pagination.page"
            @update:activePage="updatePage"
            :pages="data.pagination.num_pages"
        />
      </template>
      <!-- Filtri select automatici per fields con filter.type === 'select' -->
      <template v-for="field in selectFilterFields" v-slot:[`${field.key}-filter`]="slotData">
        <CSelect
            :key="field.key"
            size="sm"
            :options="field.filter.values"
            :value.sync="filters[field.key]"
            @update:value="onSelectFilterChange"
        />
      </template>

      <!-- Pass-through degli altri slot -->
      <template v-for="(slot, name) in $scopedSlots" v-slot:[name]="slotData">
        <slot :name="name" v-bind="slotData"></slot>
      </template>
    </CDataTable>
</template>

<script>

export default {
  name: "AjaxTable",
  props: {
    fields: {type: Array},
    data: {type: Object},
    fetch: {type: Function}
  },
  emits: [],
  data() {
    return {
      pagination: {
        page_size: 20,
        page: 1,
      },
      sorting: {
        column: null,
        asc: false
      },
      filters: {},
      loading: true,
    }
  },
  computed: {
    selectFilterFields() {
      // Ritorna i fields che hanno filter.type === 'select'
      if (!this.fields) return []
      return this.fields.filter(field => field.filter && field.filter.type === 'select')
    }
  },
  mounted() {
    // Inizializza filtri di default dai fields
    this.initializeDefaultFilters()
    this.fetchList()
  },
  methods: {
    initializeDefaultFilters() {
      // Legge i valori di default dai fields con filter.default
      if (!this.fields) return

      const defaultFilters = {}
      this.fields.forEach(field => {
        if (field.filter && field.filter.default !== undefined) {
          defaultFilters[field.key] = field.filter.default
        }
      })

      this.filters = {...defaultFilters, ...this.filters}
    },
    async fetchList() {
      this.loading = true
      await this.fetch({
        filters: this.filters,
        pagination: this.pagination,
        sorting: this.sorting
      })
      this.pagination.page = this.data.pagination.page
      this.loading = false
    },
    updateFilters(filters) {
      this.filters = filters
      this.pagination.page = 1
      this.fetchList()
    },
    updateSorting(sorting) {
      this.sorting = sorting
      this.fetchList()
    },
    updatePage(page) {
      this.pagination.page = page
      this.fetchList()
    },
    onSelectFilterChange() {
      // Quando cambia un filtro select, aggiorna la lista
      this.pagination.page = 1
      this.fetchList()
    }
  }
}
</script>